<template>
  <ResultForm :data="lotto" @save="save"></ResultForm>
</template>
<script>
import LottoService from "@/services/lottoService"

import moment from "moment"

import ResultForm from "./ResultForm.vue"

export default {
  components: {
    ResultForm
  },
  data() {
    return {
      lotto: {
        lotto_date: moment().format("YYYY-MM-DD"),
        start_spin: moment().add(1, 'd').format("YYYY-MM-DD 00:50"),
        show_1st: moment().add(1, 'd').format("YYYY-MM-DD 01:00"),
        show_2nd: moment().add(1, 'd').format("YYYY-MM-DD 00:55"),
        results: {
          prize_1st: '',
          prize_2nd: '',
          prize_3rd_1: LottoService.randomNumber(5),
          prize_3rd_2: LottoService.randomNumber(5),
          prize_3rd_3: LottoService.randomNumber(5),
          special_1: LottoService.randomNumber(5),
          special_2: LottoService.randomNumber(5),
          special_3: LottoService.randomNumber(5),
          special_4: LottoService.randomNumber(5),
          special_5: LottoService.randomNumber(5),
          special_6: LottoService.randomNumber(5),
          special_7: LottoService.randomNumber(5),
          special_8: LottoService.randomNumber(5),
          consolation_1: LottoService.randomNumber(2),
          consolation_2: LottoService.randomNumber(2),
          consolation_3: LottoService.randomNumber(2),
          consolation_4: LottoService.randomNumber(2)
        }
      },
    }
  },
  methods: {
    save(data) {
      LottoService.saveResult(data).then((response) => {
        try {
          if (response.status === 'success') {
            this.$vs.notify({
              title: 'สำเร็จ!',
              text: 'บันทึกผลหวยเสร็จเรียบร้อย',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });

            this.$router.push({ name: 'admin-results' })
          } else {
            this.$vs.notify({
              title: 'ผิดพลาด!',
              text: 'บันทึกผลหวยไม่สำเร็จ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        } catch (e) {
          //console.log(e)
          this.$vs.notify({
            title: 'ผิดพลาด(2)!',
            text: 'บันทึกผลหวยไม่สำเร็จ',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      })
    }
  }
}

</script>
